export default __webpack_public_path__ + "static/media/dsv-ups-dom_de.56ed4b3b.svg";